export const initialCustomerState = {
  name: '',
  phone: '',
  discount: 0,
  paymentMode: '',
};
